<template>
  <section class="descriptions">
    <Card :bordered="false" dis-hover>
      <p slot="title">{{ title }}</p>
      <Form ref="formValidate" :label-width="120">
        <Row :gutter="32">
          <Col span="7" v-for="(item, index) in data" :key="index">
            <Form-item :label="item.label" :key="index" style="margin: 0;">
              <div
                @click="openModal(item.values)"
                v-if="item.type == 'photo'"
                :style="{ cursor: 'pointer' }"
              >
                <Icon type="ios-image" size="16" color="#5586ff" />
                <a>查看</a>
              </div>
              <div v-else>
                {{ item.values }}
              </div>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </Card>
    <Modal
      footer-hide
      title="查看图片"
      v-model="visiable"
      class="vertical-center-modal"
    >
      <div style="text-align: center;max-width: 300;">
        <img :src="photoUrl" />
      </div>
    </Modal>
  </section>
</template>

<script>
export default {
  name: "descriptions",
  props: {
    title: {
      type: String
    },
    data: {
      type: Object,
      default: []
    }
  },
  data() {
    return {
      visiable: false,
      photoUrl: ""
    };
  },
  methods: {
    openModal(v) {
      this.photoUrl = v;
      this.visiable = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/shopTask/components/descriptions.vue